import IconButton from "@mui/material/IconButton"
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined"
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined"
import MenuOpenIcon from "@mui/icons-material/MenuOpen"

export const DrawerButton = (props) => {
  const style = {
    color: "var(--text)",
  }
  return (
    <IconButton
      sx={{
        border: "1px solid var(--border)",
        padding: "3px",
        background: "var(--surface)",
        ":hover": {
          borderColor: "var(--accent)",
          background: "var(--surface)",
        },
        ...props.sx,
      }}
      size="small"
      {...props}
    >
      {props.icon === "open" && <ChevronRightOutlinedIcon style={style} />}
      {props.icon === "close" && <ChevronLeftOutlinedIcon style={style} />}
      {props.icon === "filter" && <MenuOpenIcon style={style} />}
    </IconButton>
  )
}
